import { Pipe, PipeTransform } from '@angular/core';
import StringMask from 'string-mask';
import {flagOptions} from '../constants/flag-Input-const';

@Pipe({
  name: 'formatPhoneDDI'
})
export class FormatPhoneDDIPipe implements PipeTransform {
  // Apply phone mask using DDI as param

  transform(value: string, ...args: unknown[]): unknown {
    const ph = value.replace(/[^0-9]/g, '');
    const flag = flagOptions.find(ddi => ddi.prefix === args[0]);
    switch (args[0]) {
      case '+55':
        if (ph.length === 11) {
          return new StringMask(flag.pattern[0]).apply(ph);
        }
        return new StringMask(flag.pattern[1]).apply(ph);

      case '+1':
        return new StringMask(flag.pattern[0]).apply(ph);

      case '+351':
        return new StringMask(flag.pattern[0]).apply(ph);

    }
  }

}
